import { defineComponent as _defineComponent } from 'vue';
import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "input-group mt-3" };
var _hoisted_2 = ["type"];
var _hoisted_3 = { class: "input-group mt-3" };
var _hoisted_4 = ["type"];
import { useAuthStore } from '@/stores/authStore';
import { computed, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UpdatePassword',
    setup: function (__props) {
        var register = ref({
            password: '',
            confirmPassword: '',
        });
        var seePass = ref(false);
        var seeRep = ref(false);
        var auth = useAuthStore();
        var passwordLevel = computed(function () {
            var value = register.value.password;
            var score = 0;
            if (value.length >= 8)
                score++;
            if (/[A-Z]/.test(value))
                score++;
            if (/[a-z]/.test(value))
                score++;
            if (/\d/.test(value))
                score++;
            if (/[^A-Za-z0-9]/.test(value))
                score++;
            if (score <= 2)
                return 'Bajo';
            if (score === 3)
                return 'Medio';
            if (score === 4)
                return 'Alto';
            return 'Seguro';
        });
        var colorLevel = computed(function () {
            switch (passwordLevel.value) {
                case 'Bajo':
                    return 'red';
                case 'Medio':
                    return 'orange';
                case 'Alto':
                    return 'blue';
                case 'Seguro':
                    return 'green';
                default:
                    return 'gray';
            }
        });
        return function (_ctx, _cache) {
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((register.value.password) = $event); }),
                        placeholder: "Contraseña",
                        type: seePass.value ? 'text' : 'password'
                    }, null, 8, _hoisted_2), [
                        [_vModelDynamic, register.value.password]
                    ]),
                    _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (seePass.value = !seePass.value); })
                    }, [
                        _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', seePass.value ? 'eye' : 'fa-eye-slash']
                        }, null, 8, ["icon"])
                    ])
                ]),
                (register.value.password)
                    ? (_openBlock(), _createElementBlock("small", {
                        key: 0,
                        style: _normalizeStyle({ color: colorLevel.value })
                    }, "Seguridad: " + _toDisplayString(passwordLevel.value), 5))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((register.value.confirmPassword) = $event); }),
                        placeholder: "Confirmar contraseña",
                        type: seeRep.value ? 'text' : 'password'
                    }, null, 8, _hoisted_4), [
                        [_vModelDynamic, register.value.confirmPassword]
                    ]),
                    _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = function ($event) { return (seeRep.value = !seeRep.value); })
                    }, [
                        _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', seeRep.value ? 'eye' : 'fa-eye-slash']
                        }, null, 8, ["icon"])
                    ])
                ]),
                (register.value.confirmPassword)
                    ? (_openBlock(), _createElementBlock("small", {
                        key: 1,
                        style: _normalizeStyle({ color: register.value.password === register.value.confirmPassword ? 'green' : 'red' })
                    }, _toDisplayString(register.value.password === register.value.confirmPassword && register.value.confirmPassword.length > 0 ? 'Las contraseñas coinciden' : 'Las contraseñas no coinciden'), 5))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row justify-content-center px-4 pt-3" }, [
                    _createElementVNode("button", { class: "btn btn-primary" }, "Actualizar")
                ], -1))
            ]));
        };
    }
});
